// extracted by mini-css-extract-plugin
export var fadeIn = "_gu-1";
export var modalContent = "_gu-3";
export var overlay = "_gu-0";
export var popoverContent = "_gu-2";
export var results = "_gu-5";
export var searchInputWrapper = "_gu-4";